import { Link } from '@tanstack/react-router';

export const Like = ({ children, to, title, ...props }: { children: React.ReactNode, to: string, title?: string }) => (
  <Link to={to} title={title} {...props} style={{
    fontSize: '15px',
    display: 'inline-block',
    padding: '0 3px',
    textAlign: 'center',
    marginTop: '1px',
    boxShadow: 'none',
  }}>
    {children}
  </Link>
);